/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card :class="{ 'remove_card': propOpenedInModal }">
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardSubHeader }}</p>
            <ValidationObserver ref="carrForm">
              <form action="#">
                <div class="col-md-12 mb-3">
                  <label for="validationname">
                    {{cvNameLabel}}</label>
                  <multiselect
                    v-model="vmGPathCareertypeFormData.name"
                    :tag-placeholder="cvSelectLabel"
                    :placeholder="cvSelectLabel"
                    :searchable="true"
                    :options="gpathCareerName"
                    :taggable="true"
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationname">
                    {{cvName2Label}}</label>
                  <input
                    v-model="vmGPathCareertypeFormData.name2"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationkey">
                    {{cvKeyLabel}}</label>
                  <input
                    v-model="vmGPathCareertypeFormData.career_key"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                 <div class="col-md-12 mb-3">
                  <label for="validationcarr_field" class="w-100">{{cvCarrImageLabel}}</label>
                  <div class="profile-img-edit border" style="height: 150px; width: 150px; border-radius: 50%; ">
                    <img v-if="vmProfilePic" :src="vmProfilePic" alt="profile-pic " style="height: 100%; width: 100%; object-fit: cover; overflow: hidden; border-radius: 50%; " />
                    <i v-else class="fas fa-image d-flex justify-content-center align-items-center rounded-circle" style="font-size: 5rem; height:100%; color: #c1c1c1;"></i>
                    <label class="p-image">
                      <i class="ri-pencil-line upload-button" title="Upload Image" style="cursor: pointer;"></i>
                      <input class="file-upload" type="file" accept="image/png,image/jpeg,image/jpg" id="fileInput1" style="display: block; position: absolute; opacity: 0; left: 0; top: 0; pointer-events: none;" @change="openImageDialog($event, 'Profile Pic')" required />
                    </label>
                  </div>
                  <br/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">
                    {{cvTitleLabel}}</label>
                  <input
                    v-model="vmGPathCareertypeFormData.title"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationdetail">
                    {{cvDetailLabel}}</label>
                  <textarea
                    v-model="vmGPathCareertypeFormData.detail"
                    type="text"
                    class="textarea form-control"
                    required></textarea>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationabout">
                    {{cvAboutLabel}}</label>
                  <textarea
                    v-model="vmGPathCareertypeFormData.about"
                    type="text"
                    class="textarea form-control"
                    required></textarea>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationkey">
                    {{cvUrlLabel}}</label>
                  <input
                    v-model="vmGPathCareertypeFormData.url"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvSalaryLabel}}</label>
                    <ValidationProvider
                      name="salary"
                      rules="required"
                      v-slot="{ errors }">
                      <input
                        v-model="vmGPathCareertypeFormData.salary"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvSubjectLabel}}</label>
                    <ValidationProvider
                      name="subjects"
                      rules="required"
                      v-slot="{ errors }">
                      <input
                        v-model="vmGPathCareertypeFormData.subjects"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvProgramsLabel}}</label>
                    <ValidationProvider
                      name="programs"
                      rules="required"
                      v-slot="{ errors }">
                      <input
                        v-model="vmGPathCareertypeFormData.programs"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvCareerPathsLabel}}</label>
                    <ValidationProvider
                      name="Career Roles"
                      rules="required"
                      v-slot="{ errors }">
                    <vue-editor v-model="vmGPathCareertypeFormData.career_paths"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvCareerRolesLabel}}</label>
                    <ValidationProvider
                      name="Career Roles"
                      rules="required"
                      v-slot="{ errors }">
                    <vue-editor v-model="vmGPathCareertypeFormData.career_roles"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvCareerFactsLabel}}</label>
                    <ValidationProvider
                      name="Career facts"
                      rules="required"
                      v-slot="{ errors }">
                    <vue-editor v-model="vmGPathCareertypeFormData.career_facts"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvHiringCompaniesLabel}}</label>
                    <ValidationProvider
                      name="Hiring Companies"
                      rules="required"
                      v-slot="{ errors }">
                    <vue-editor v-model="vmGPathCareertypeFormData.hiring_companies"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvCareerMythsLabel}}</label>
                    <ValidationProvider
                      name="Hiring Companies"
                      rules="required"
                      v-slot="{ errors }">
                    <vue-editor v-model="vmGPathCareertypeFormData.career_myths"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                    <b-spinner label="Spinning"></b-spinner>
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="gpath_career_role_add()">
                    {{ cvSubmitBtn }}
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <CropImage :prop-crop-image-dialog-open="propCropImageDialogOpen" :propCropModalSize="propCropDialogSize" :prop-stencil-size="propStencilSize" :propSrc="fileSrc" @emitCroppedImg="getCroppedImg" @emitCroppedImgFile="emitCroppedImgFile" />
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { GPathCareers } from "../../../FackApi/api/GPathCareer"
import { GPathCareerType } from "../../../FackApi/api/GPathCareerType.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission"
import { VueEditor } from "vue2-editor"
import { ValidationProvider } from "vee-validate"
import CropImage from "../../../components/cropImage.vue"
import { Images } from "../../../FackApi/api/image.js"
import Multiselect from "vue-multiselect"

export default {
  name: "GPathCareerRoleAdd",
  components: {
    VueEditor,
    ValidationProvider,
    CropImage,
    Multiselect
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      apiName: "gpath_career_type_add",
      cvCardTitle: "Add GPaths Career Type",
      cvCardSubHeader: "Add GPaths Career Type",
      cvSubmitBtn: "Add",
      cvNameLabel: "Name",
      cvName2Label: "Name2",
      cvSelectLabel: "Select ",
      cvKeyLabel: "Key",
      cvTitleLabel: "Title",
      cvDetailLabel: "Detail",
      cvAboutLabel: "About",
      cvUrlLabel: "Url",
      cvSalaryLabel: "Salary",
      cvSubjectLabel: "subjects",
      cvProgramsLabel: "programs",
      cvCareerPathsLabel: "Career Paths",
      cvCareerRolesLabel: "Career Roles",
      cvCareerFactsLabel: "Career Facts",
      cvHiringCompaniesLabel: "Hiring Companies",
      cvCareerMythsLabel: "Career Myths",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "GPaths Career Type Add",
      vmGPathCareertypeFormData: Object.assign({}, this.initFormData()),
      vmGPathCareertypeDesc: null,
      vmGPathCareertypeType: null,
      fileSrc: "",
      vmCarProPicImage: Object.assign({}, this.initImageData()),
      vmCarCoverPicImage: Object.assign({}, this.initImageData()),
      cvCarrImageLabel: "Carrer Image",
      vmProfilePic: "",
      propCropImageDialogOpen: false,
      propCropDialogSize: "md",
      propStencilSize: null,
      gpathCareerName: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
    this.gpath_careerList()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        "name": "",
        "name2": "",
        "career_key": "",
        "title": "",
        "detail": "",
        "about": "",
        "url": "",
        "salary": "",
        "subjects": "",
        "programs": "",
        "career_paths": "",
        "career_roles": "",
        "career_facts": "",
        "hiring_companies": "",
        "career_myths": ""
      }
    },
    /**
     * va,idate
     */
    validate () {
      try {
        for (let index in this.vmGPathCareertypeFormData) {
          if (!this.vmGPathCareertypeFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_role_add
     */
    async gpath_career_role_add () {
      // if (!this.validate()) {
      //   return false
      // }
      try {
        this.cvLoadingStatus = true
        let gpathCareerTypeAddResp = await GPathCareerType.gpath_career_role_add(this, this.vmGPathCareertypeFormData)
        await ApiResponse.responseMessageDisplay(this, gpathCareerTypeAddResp)
        if (gpathCareerTypeAddResp && !gpathCareerTypeAddResp.resp_status) {
          return false
        }

        if (gpathCareerTypeAddResp.resp_data && gpathCareerTypeAddResp.resp_data.gpct_id) {
          this.cvLoadingStatus = false
          await this.imageAdd(gpathCareerTypeAddResp.resp_data.gpct_id)
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseGPathCareertypeAddModal", gpathCareerTypeAddResp.resp_data)
        }
        this.vmGPathCareertypeFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_role_add() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * getCroppedImg
     */
    getCroppedImg (img) {
      if (this.updateImageType === "Profile Pic") {
        this.vmProfilePic = img
      }
      else {
        this.vmCoverPic = img
      }
    },
    /**
     * imageAdd
     */
    async imageAdd (gpctId) {
      if (this.cvImageError) {
        return
      }
      try {
        this.cvImageLoadingStatus = true
        let imageObj = {
          "module_name": "GPCT",
          "module_id": gpctId,
          "image": []
        }

        if (imageObj.image.length < 1) {
          return false
        }

        const imageUpdateResp = await Images.imageProfileAdd(this, imageObj)
        await ApiResponse.responseMessageDisplay(this, imageUpdateResp)
        if (imageUpdateResp && !imageUpdateResp.resp_status) {
          return false
        }
        this.vmCarProPicImage = Object.assign({}, this.initImageData())
      }
      catch (err) {
        console.error("Exception occurred at imageAdd() and Exception:", err.message)
      }
      finally {
        this.cvImageLoadingStatus = false
      }
    },
    /**
     * emitCroppedImgFile
     */
    emitCroppedImgFile (imgObj) {
      let img = imgObj.imgFile
      let orgImg = imgObj.orgImage
      let imageType = this.updateImageType
      this.onChangeProfileImage(img, imageType)

      if (imageType === "Profile Pic") {
        this.vmCarProPicImage = Object.assign({}, this.initImageData())
        this.vmCarProPicImage.image = {
          "img": img,
          "name": orgImg.name
        }
        this.vmCarProPicImage.image_type = "profile_pic"
      }
      else {
        this.vmCarCoverPicImage = Object.assign({}, this.initImageData())
        this.vmCarCoverPicImage.image = {
          "img": img,
          "name": orgImg.name
        }
        this.vmCarCoverPicImage.image_type = "cover_pic"
      }
    },
    /**
     * openImageDialog
     */
    openImageDialog (e, imageType) {
      this.updateImageType = imageType
      if (e.target.files.length > 0) {
        this.fileSrc = e.target.files[0]
      }

      let input = e.target
      if (input.files.length > 0 && input.files[0]) {
        let image = input.files[0]
        let allowedExtension = [ "image/png", "image/jpg", "image/jpeg", "image/webp" ]
        let maxSize = 4 * 1024 * 1024

        if (!allowedExtension.includes(image.type)) {
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          return false
        }
        else if (image.size > maxSize) {
          // validate image size
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.showToast = true
          }
          return false
        }

        if (imageType === "Profile Pic") {
          this.propStencilSize = {
            "width": 150,
            "height": 150
          }
          this.propCropDialogSize = "md"
        }
        else {
          this.propStencilSize = {
            "width": 970,
            "height": 240
          }
          this.propCropDialogSize = "xl"
        }
        this.propCropImageDialogOpen = Math.random()
      }
    },
    /**
     * initImageData
     */
    initImageData () {
      return {
        image: "",
        image_type: ""
      }
    },
    /**
     * onChangeProfileImage
     */
    onChangeProfileImage (e, imageType) {
      try {
        const reader = new FileReader()
        reader.onload = async (e) => {
          if (imageType === "Profile Pic") {
            this.vmProfilePic = await reader.result
          }
          else {
            this.vmCoverPic = await reader.result
          }
        }
        // reader.readAsDataURL(image)
      }
      catch (err) {
        console.error("Exception occurred at onChangeProfilePic() and Exception:", err.message)
      }
    },
    /**
     * gpath_careerList
    */
    async gpath_careerList () {
      try {
        let gpathCareerListResp = await GPathCareers.gpath_careerList(this, this.whereFilter)
        if (gpathCareerListResp.resp_status) {
          this.gpath_careerObjList = gpathCareerListResp.resp_data.data
          this.gpathCareerName = this.gpath_careerObjList.map(item => item.name)
          this.totalRows = gpathCareerListResp.resp_data.count
        }
        else {
          this.toastMsg = gpathCareerListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at gpath_careerList() and Exception:", err.message)
      }
    }
  }
}
</script>
<style scoped>
 textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
